import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'home-infographics',
  templateUrl: './infographics.component.html',
  styleUrls: ['./infographics.component.sass']
})
export class InfographicsComponent {

  constructor() { }

  _opacity = 0;

  pool: Element[] = [
  // cls rs 
    // house
    new Element('rsHouse', 116),
    // text
    new Element('rstxt', -76),
  // cls pi
    // text
    new Element('pitxt', 39),
  // cls data
    // house
    new Element('dataHouse', 56),
    // text
    new Element('datatxt', -17),
  // cls gs
    // house
    new Element('gsHouse', 5),
    // text
    new Element('gstxt', 32)
  ]

  @HostListener('window:scroll', ['$event']) scrollPosition() {

    let scrollPosition = window.pageYOffset;

    let _fci = document.getElementById('fciSun');
    let _margin = _fci.style.marginLeft;
    let _val = _margin.slice(0,_margin.length - 2);

    const start = 0;
    const end = 400;

    // based on scroll position ...
    if (scrollPosition >= start && scrollPosition <= end) {
      // ... loop through elements ...
      this.pool.forEach( (_e) => {
        // ... translate via css
        document.getElementById(_e.id).style.transform = ('translateY(' + (scrollPosition * (_e.value / end)) + 'px)'); 
      });

      // fci sun
      _fci.style.transform = 'translate(' + (scrollPosition * ( (parseInt(_val) * -1.8) / end)) + 'px, '+ (scrollPosition * ( -180 / end) + 'px)');

      this._opacity = this.opacityTransform(400, scrollPosition);
    }
  }

  private opacityTransform(_a: number, _b: number): number {

    let value = 1 - (_a - _b) / _a;

    this._opacity = value;    

    return this._opacity
  }
}

class Element {
  id: string;
  value: number;

  constructor(_i: string, _v: number) {
    this.id = _i;
    this.value = _v;
  } 
} 